import { create, FedopsLogger } from '@wix/fedops-logger';
import { InteractionName } from '../../types/InteractionName';
import { FEDOPS_LOGGER_ID } from './constants';

export const fedopsLogger: FedopsLogger<InteractionName> =
  create(FEDOPS_LOGGER_ID);
